
import { mapState, mapActions } from 'vuex'
import dayjs from 'dayjs'
import SearchPeriod from '~/components/Common/UI/Search/SearchPeriod'

export default {
    name: 'ListBoard',
    components: {
        SearchPeriod,
    },
    props: {
        items: {
            type: Array,
            default() {
                return []
            },
        },
        blog: Boolean,
        normal: Boolean,
    },

    data() {
        return {
            onAndoff: !this.blog,
            limitedDate: '',        // 기간 제한 변수 
            rowGrey: [],            // 주식신문 음영 변수
            titleTemp: [],          // 제목 길이 구분값 
            searchPlaceholder: "제목을 입력해주세요",
            startDate: null, // params.startDate
            endDate: null, // params.endDate
        }
    },
    computed: {
        ...mapState('board', ['colList']),
        ...mapState ({
            MEMBER_INFO : state => state.member.memberInfo,
        }),
    },
    created() {
        // reset values
        this.rowGrey = []
        this.limitedDate = ''

        // 220610 meej 메인페이지에서 속보제목 클릭해서 들어올경우 조회값 변경
        const query = this.$route.query
        if(query.sendDate){
            const YYYY = query.sendDate.substring(0, 4)
            const MM = query.sendDate.substring(4, 6)
            const DD = query.sendDate.substring(6, 8)
            this.startDate = YYYY + '-' + MM + '-' + DD
        }else{
            this.startDate = dayjs(new Date()).format('YYYY-MM-DD')
        }
         // 초기값 
        this.endDate = dayjs(new Date()).format('YYYY-MM-DD')

    },
    beforeUpdate() {
        console.log('menutype, newstype CHECK: ', this.items)

        /* 22.04.18 suye newsType1에 따른 메서드 분리 */
        if(this.items !== undefined && this.items !== null && this.items.length !== 0){
            if(this.items[0].newsType1 !== null){
                if(this.items[0].newsType1.includes('MARKET_FLASH_') ) { 
                    this.dayLimitChk(this.items) 
                } 
            }
        }

        /* 22.04.21 suye 제목 길이 체크 및 변경 함수 */
        this.titleTemp = []
        let replaceTitle = ''
        let num = 0
        // 필요시 daily테마 newsType1만으로 조건 제한해야함
        this.items.forEach(e => { 
            if(e.title.length > 80){
                // 제목의 길이가 n보다 길면 잘라서 앞에 보여주고 뒤는 '...' 처리 
                replaceTitle = e.title.substring(0, 80).trim()  
                // 잘리는 기준 쉼표,슬래쉬로 자르기 
                const isComma = replaceTitle.lastIndexOf(',')
                const isSlash = replaceTitle.lastIndexOf('/')
                if(isComma !== -1 && isSlash !== -1){ // 쉼표,슬래쉬 둘다 존재할 때
                    if(isComma >= isSlash){
                        replaceTitle = replaceTitle.substr(0,isComma).trim() + '...' 
                        // console.log('isComma: ', replaceTitle.substr(0,isComma))
                    } else {
                        replaceTitle = replaceTitle.substr(0,isSlash).trim() + '...' 
                        // console.log('isSlash: ', replaceTitle.substr(0,isSlash))
                    }
                } else if (isComma !== -1){ // 쉼표만 존재할 때
                    replaceTitle = replaceTitle.substr(0,isComma).trim() + '...' 
                } else if (isSlash !== -1){ // 슬래쉬만 존재할 때 
                    replaceTitle = replaceTitle.substr(0,isSlash).trim() + '...' 
                } 
            } else { // 제목 길이 적당하면
                replaceTitle = e.title    
            }
            this.titleTemp.push({num, replaceTitle})
            num++
        });
    },
    methods: {
        ...mapActions( 'modal', ['SHOW_ALERT']),

        // 22.11.04 suye 수정 
        // 22.04.15 suye 기간제한일자 반환 함수: 오늘일자 - num => 기준일자 
        limitDateMaker(num){
            // 현재일자  
            const today = new Date();
            const year = today.getFullYear();
            const month = ('0' + (today.getMonth() + 1)).slice(-2);
            const day = ('0' + today.getDate()).slice(-2);

            // 현재일자 기준 -n일
            const dateLimit = new Date(year, Number(month)-1, day) 

            dateLimit.setDate(dateLimit.getDate() - num)

            // let limited = dateLimit.toLocaleDateString().replace(/\./g, '').replace(/(\s*)/g, "") // 일자 yyyyMMdd
            let limited = dateLimit.toLocaleDateString()
            // console.log('limited', limited)
            const changed = []
            const final = []
            if(limited.includes('.')){
                const splited = limited.split('.')
                if(splited.indexOf('') !== -1) splited.splice(splited.indexOf(''))
                // console.log('splited', splited)
                splited.forEach(e => {
                    changed.push(e.trim())
                });
            }
            if(changed && changed.length > 0){
                changed.forEach(e => {
                    if(e.length === 1){
                        e = '0'+e
                    }
                    final.push(e)
                });
            // console.log('final', final)
            }
            limited = final.join('')
            console.log('limited', limited)

            return limited
        },
        
        // 22.04.19 suye 속보자료 오늘일자 제외 
        dayLimitChk(items){
            this.rowGrey = []
            this.limitedDate = this.limitDateMaker(0)
            console.log('items: ', items)
            let idx = 0
            if(this.MEMBER_INFO == null || (this.MEMBER_INFO !== null && this.MEMBER_INFO.type !== 'REGULAR' && this.MEMBER_INFO.type !== 'CORPORATE')){ // 유료회원 아닐때 
                items.forEach(e => {
                    if(e.sendDate !== null && e.sendDate !== undefined && e.sendDate !== ''){     // sendDate로 들어올 경우 
                        if(e.sendDate === this.limitedDate){                                      // 현재일자 제외 
                            idx++
                            this.rowGrey.push(idx)                                                // row구분
                        }
                    } else if(e.sendDate === null && e.showDate !== null){                        // showDate로 들어올 경우
                        if(e.showDate === this.limitedDate){                                      // 현재일자 제외 
                            idx++
                            this.rowGrey.push(idx)                                                // row구분
                        }
                    }
                });
            }
        },

        // 속보자료: 비회원,무료회원 -> 오늘일자 자료 제외하고 보여주기
        onClickItem(item) {
            if(this.MEMBER_INFO === null || (this.MEMBER_INFO !== null && this.MEMBER_INFO.type !== 'REGULAR' && this.MEMBER_INFO.type !== 'CORPORATE')){ // 비회원 또는 무료회원일때
                if('sendDate' in item && item.sendDate !== null && item.sendDate !== undefined && item.sendDate !== ''){          // sendDate일 경우 
                    if(item.sendDate === this.limitedDate){
                        this.SHOW_ALERT({ content: '유료회원님들을 위한 자료입니다.'})
                    } else {
                        this.$emit('clickItem', { ...item })
                    }
                } else if('showDate' in item && item.showDate !== null && item.showDate !== undefined && item.showDate !== '') {  // showDate일 경우
                    if(item.showDate === this.limitedDate){
                        this.SHOW_ALERT({ content: '유료회원님들을 위한 자료입니다.'})
                    } else {
                        this.$emit('clickItem', { ...item })
                    }
                }
            } else {
                this.$emit('clickItem', { ...item })
            }
        },
        onClickUpDown() {
            this.onAndoff = !this.onAndoff
        },
    },
}
